<script lang="ts">
	import RequiredMark from "@components/form/RequiredMark.svelte";
	import type { Snippet } from "svelte";
	import type { ClassValue, HTMLAttributes, HTMLInputAttributes, HTMLLabelAttributes } from "svelte/elements";

	const {
		horizontal,
		label,
		required,
		content,
		wrapperClass,
		...rest
	}: HTMLAttributes<HTMLDivElement> & {
		wrapperClass?: ClassValue;
		required?: HTMLInputAttributes["required"];
		horizontal?: boolean;
		label?: HTMLLabelAttributes;
		content: Snippet;
	} = $props();
</script>

<div class={["flex text-left gap-1.5 md:gap-3", horizontal ? "flex-row items-center" : "flex-col", wrapperClass]}>
	{#if horizontal}
		{@render content()}
	{/if}
	<label {...label}>
		{@render rest.children?.()}
		{#if required}
			<RequiredMark class="self-start" />
		{/if}
	</label>
	{#if !horizontal}
		{@render content()}
	{/if}
</div>
